{
  "label": "Системное имя",
  "tooltip": {
    "iconLabel": "Подсказка для системного имени",
    "systemUsage": "Используется внутри системы",
    "allowedCharacters": "Допустимые символы: латиница (a-z), цифры (0-9) и нижнее подчеркивание (_)",
    "unique": "Должно быть уникальным в рамках своей области видимости",
    "immutable": "Не подлежит редактированию после создания сущности"
  }
}